import templateUrl from "./stages.html";
import "./stages.scss";

export const stagesComponent = {
  bindings: {
    userDetails: "<",
    details: "<",
  },
  templateUrl,
  controller: class StagesComponent {
    constructor($state, toastr, $stateParams, Constants, StageService) {
      "ngInject";

      this.$state = $state;
      this.toastr = toastr;
      this.Constants = Constants;
      this.stateParams = $stateParams;
      this.StageService = StageService;
    }
    $onInit() {
      // update the status in boolean value so as to check/uncheck the checkboxes
      this.details.taskList = this.details.taskList.map((task) => {
        task.status = task.status ? true : false;
        return task;
      });
      this._taskListApprovedUnmodified = angular.copy(
        this.details.taskList.filter((task) => task.status)
      );
      this.disableApproveBtn = false;
    }
    onTaskCheckboxChange(item) {
      // return this.details.taskList.map((value) => {
      //   if (value.taskId === item.taskId) {
      //     if (!value.status) {
      //       value.status = false;
      //     } else {
      //       value.status = true;
      //     }
      //   }
      //   return value;
      // });
    }

    onSubmit() {
      if (
        JSON.stringify(this._taskListApprovedUnmodified) !==
        JSON.stringify(this.details.taskList.filter((task) => task.status))
      ) {
        this.disableApproveBtn = true;
        const { stageId, memberId } = this.stateParams;
        const taskIds = this.details.taskList
          .filter((task) => task.isApproved)
          .map((task) => task.taskId);
        this.StageService.approveMemberTasks(stageId, memberId, taskIds)
          .then((_) => {
            this.disableApproveBtn = false;
            this.toastr.success("Changes updated successfully");
            this._taskListApprovedUnmodified = angular.copy(
              this.details.taskList.filter((task) => task.status)
            );
          })
          .catch((errmsg) => {
            this.disableApproveBtn = false;
            this.toastr.error(errmsg);
          });
      } else {
        this.toastr.success("Nothing to update");
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/stages/stages.component.js